import { render, staticRenderFns } from "./confirmActionTitle.vue?vue&type=template&id=24db4567&scoped=true&lang=html&"
import script from "./confirmActionTitle.vue?vue&type=script&lang=js&"
export * from "./confirmActionTitle.vue?vue&type=script&lang=js&"
import style0 from "./confirmActionTitle.vue?vue&type=style&index=0&id=24db4567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db4567",
  null
  
)

export default component.exports